module.exports = __webpack_public_path__ + "static/media/icons_Bilan des praxies linguales.e34e8498.svg";